import { render, staticRenderFns } from "./AdditionalQuestionsEgressProcess.vue?vue&type=template&id=06235f04&scoped=true&"
import script from "./AdditionalQuestionsEgressProcess.vue?vue&type=script&lang=js&"
export * from "./AdditionalQuestionsEgressProcess.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalQuestionsEgressProcess.vue?vue&type=style&index=0&id=06235f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06235f04",
  null
  
)

export default component.exports